import e from "react";
import { componentName as r } from "../../../utils/bem/index.js";
import { Tag as t } from "./Tag.js";
import { Icon as o } from "../Icon/Icon.js";
function n(n) {
  var l = n.children,
    a = n.color,
    c = n.removeLabel,
    i = n.onRemove,
    m = function (e, r) {
      if (null == e) return {};
      var t,
        o,
        n = function (e, r) {
          if (null == e) return {};
          var t,
            o,
            n = {},
            l = Object.keys(e);
          for (o = 0; o < l.length; o++) t = l[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
          return n;
        }(e, r);
      if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(e);
        for (o = 0; o < l.length; o++) t = l[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
      }
      return n;
    }(n, ["children", "color", "removeLabel", "onRemove"]);
  return m.className = r("removable-tag", m.className, {}), e.createElement(t, function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {},
        o = Object.keys(t);
      "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      }))), o.forEach(function (r) {
        var o;
        o = t[r], r in e ? Object.defineProperty(e, r, {
          value: o,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[r] = o;
      });
    }
    return e;
  }({
    color: void 0 === a ? "" : a
  }, m), l, e.createElement(o, {
    regular: !0,
    name: "times",
    role: "button",
    "aria-label": c,
    tabIndex: 0,
    className: r("removable-tag__close"),
    onClick: i,
    onKeyDown: function onKeyDown(e) {
      ("Enter" === e.key || " " === e.key) && i();
    }
  }));
}
n.displayName = n;
export { n as RemovableTag };